import RatingComponentPageWrapper from 'components/rating/RatingComponentPageWrapper';

export default function RatingComponentWrapper({ props }: { props: any }) {
    const itemType = String(props.itemType) === 'page' ? 'page' : 'element';

    return <RatingComponentPageWrapper itemId={String(props.itemId)} itemType={itemType} />;
}
